export const pageContainerStyle = "flex flex-col w-full h-full";
export const pageContentStyle = "flex flex-col w-full mx-auto";
